import { render, staticRenderFns } from "./SolicitudDetalleAdmin.vue?vue&type=template&id=20c8f5f0&scoped=true&"
import script from "./SolicitudDetalleAdmin.vue?vue&type=script&lang=js&"
export * from "./SolicitudDetalleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudDetalleAdmin.vue?vue&type=style&index=0&id=20c8f5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c8f5f0",
  null
  
)

export default component.exports